import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  click(event) {
    // event.currentTarget é o <li> clicado — this.notificationTarget sempre
    // resolveria o PRIMEIRO item da lista (getter singular do Stimulus),
    // marcando/removendo a bolinha do item errado quando havia mais de um.
    const element = event.currentTarget;
    post(element.dataset.notificationReadingUrl, {
      responseKind: "turbo-stream"
    });
  }
}
